/* eslint-disable import/no-cycle,no-lonely-if */
import axios from 'axios';
import { store } from '../store/store';
import { router } from '../router/router';

const http = axios.create();

function refreshToken({ token, login = null }) {
  axios.post(`${process.env.VUE_APP_API_URL}/v1/user/refresh-token`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then(res => {
    store.dispatch('auth/refreshSession', { token: res.data.token });
  }).catch(() => {
    store.dispatch('auth/destroySession');
    router.push({ path: '/login' }).catch(() => {});
  });
}

http.interceptors.request.use(
  /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["request"] }] */
  request => {
    const {
      token, refreshDate, expireDate, login,
    } = store.state.auth;

    if (token) {
      request.headers.Authorization = `Bearer ${token}`;

      const now = Date.now();
      // Remove token if expired and redirect to login
      if (now > expireDate) {
        store.dispatch('auth/destroySession');
        router.push({ path: '/login' }).catch(() => {});
      }
      // Token needs refresh
      if (now - refreshDate > process.env.VUE_APP_JWT_REFRESH_TIME * 1000) {
        refreshToken({ token, login });
      }
    }
    return request;
  },
  error => Promise.reject(error),
);

http.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status !== 401) {
      return Promise.reject(error);
    }

    store.dispatch('auth/destroySession');
    router.push({ path: '/login' }).catch(() => {});

    return Promise.reject(error);
  },
);

export { http as axios };
